/* eslint-disable object-property-newline */
/* eslint-disable indent */
/* eslint-disable no-negated-condition */
/* eslint-disable new-cap */
import {MobxReactionUpdate} from '@adobe/lit-mobx';
import {LitElement, html, nothing} from 'lit';
import {classMap} from 'lit/directives/class-map.js';
import {DIAMOND_STEP, SETTING_STEP, DIAMOND_IMAGES, REVIEW_STEP, PRODUCT_SELECTION_STEP, DEFAULT_TITLE, DEFAULT_TITLE_PREFIX} from '../../data/constants';
import styles from './status-bar.component.scss?as=stylesheet';
import {defineCustomElement} from 'extensions/utils';

class StatusBar extends MobxReactionUpdate(LitElement) {
	static get styles () {
		return [styles];
	}

	static get properties () {
		return {
			heading: {
				type: String
			},
			store: {
				state: true,
				type: Object
			}
		};
	}

	get formattedHeading () {
		return this.heading.replace(DEFAULT_TITLE_PREFIX, '');
	}

	constructor () {
		super();

		this.heading = DEFAULT_TITLE;
		this.store = {};
	}

	renderStepPlaceholder () {
		return html`
			<div class="step">
				<div class="placeholder-step"></div>
			</div>
		`;
	}

	renderStep (step, index) {
		const realIndex = index + 1;
		switch (step) {
			default:
			case SETTING_STEP:
				return this.renderSettingStep(realIndex);
			case DIAMOND_STEP:
				return this.renderDiamondStep(realIndex);
		}
	}

	renderSteps () {
		if (!this.store?.loaded) {
			return [
				this.renderStepPlaceholder(),
				this.renderStepPlaceholder()
			];
		}

		return this.store?.stepOrder?.map(this.renderStep.bind(this));
	}

	renderInner () {
		return html`
			<div class="status-bar-steps">
				${this.renderSteps()}
				${this.renderReviewStep()}
			</div>
		`;
	}

	render () {
		return html`
			<div class="status-bar">
				<div class="status-bar-title">
					<div class="status-bar-subtitle">Design Your</div>
					${this.formattedHeading}
				</div>
				${this.renderInner()}
			</div>
		`;
	}

	renderSettingStep (number) {
		const classesMap = {
			'is-active': this.store?.step === SETTING_STEP,
			'option-selected': Boolean(this.settingSelected),
			step: true,
			'step--setting': true
		};

		if (!this.settingSelected) {
			return html`
				<div class="${classMap(classesMap)}">
					<button class="step-button" @click="${() => this.updateStep(SETTING_STEP)}" aria-label="Choose Setting">
						<span class="step-left">
							<span class="step-top">
								<span class="step-number">${number}.</span>
								Choose Setting
							</span>
							${this.renderSettingLeftBottom()}
						</span>
						<span class="step-right">
							${this.renderSettingRight()}
						</span>
					</button>
				</div>
			`;
		}

		return html`
			<div class="${classMap(classesMap)}">
				<button class="step-button" @click="${() => this.updateStep(SETTING_STEP)}" aria-label="Choose Setting">
					<span class="step-left">
						<span class="step-top">
							<span class="step-number">${number}.</span>
							Choose Setting
						</span>
						${this.renderSettingLeftBottom()}
					</span>
					<span class="step-right">
						${this.renderSettingRight()}
					</span>
				</button>
			</div>
		`;
	}

	renderSettingLeftBottom () {
		if (this.settingSelected) {
			return html`
				<span class="step-bottom step-bottom__selection">
					<div class="selection-name">${this.store?.setting?.product?.name}</div>
					<div class="selection-price">${this.formatCurrency(this.store?.setting?.product?.price)}</div>
				</span>
				<span class="selection-edit-remove">
					<a class="selection-edit step-link" href="${this.store?.editSettingHref}" @click="${(e) => this.trackEdit(e, 'Setting')}" aria-label="Edit Setting">
						Edit
					</a>
					<a class="selection-remove step-link" href="${this.store.removeSettingStepHref}" @click="${() => this.trackRemove('Setting')}" aria-label="Remove Setting">
						Remove
					</a>
				</span>
			`;
		}

		if (this.store?.step !== SETTING_STEP) {
			return html`
				<span class="step-bottom step-bottom__no-selection step-link">
					Browse Settings
				</span>
			`;
		}

		return nothing;
	}

	renderSettingRight () {
		if (!this.settingSelected) {
			return html`
				<span class="icon-ring-setting step-icon" aria-hidden="true"></span>
			`;
		}

		return html`
			<span class="selection-image setting-selection-image">
				${this.renderDiamondComposite()}
				<img .src="${this.diamondSelected ? this.store?.setting?.product?.custom?.settingUnderlayImageThumbnail : this.store?.setting?.product?.custom?.settingImageThumbnail}" .alt="${this.store?.setting?.product?.name}" />
			</span>
			<span class="selection-edit-remove">
				<a class="selection-edit step-link" href="${this.store?.editSettingHref}" @click="${(e) => this.trackEdit(e, 'Setting')}" aria-label="Edit Setting">
					Edit
				</a>
				<a class="selection-remove step-link" href="${this.store.removeSettingStepHref}" @click="${() => this.trackRemove('Setting')}" aria-label="Remove Setting">
					Remove
				</a>
			</span>
		`;
	}

	renderDiamondComposite () {
		if (!this.diamondSelected) {
			return nothing;
		}

		return html`
			<rb-diamond-overlay metal="${this.store?.setting?.product?.attributes?.rs_metal_type}" vendor="${this.store?.setting?.product?.attributes?.vendor}" ?halo="${this.store?.setting?.product?.attributes?.halo_ring_builder}" product-code="${this.store?.setting?.product?.id}"></rb-diamond-overlay>
		`;
	}

	renderDiamondStep (number) {
		const classesMap = {
			'is-active': this.store?.step === DIAMOND_STEP,
			'option-selected': Boolean(this.diamondSelected),
			step: true,
			'step--diamond': true
		};

		if (!this.diamondSelected) {
			return html`
				<div class="${classMap(classesMap)}">
					<button class="step-button" @click="${() => this.updateStep(DIAMOND_STEP)}" aria-label="Choose Diamond">
						<span class="step-left">
							<span class="step-top">
								<span class="step-number">${number}.</span>
								Choose Diamond
							</span>
							${this.renderDiamondLeftBottom()}
						</span>
						<span class="step-right">
							${this.renderDiamondRight()}
						</span>
					</button>
				</div>
			`;
		}

		return html`
			<div class="${classMap(classesMap)}">
				<button class="step-button" @click="${() => this.updateStep(DIAMOND_STEP)}" aria-label="Choose Diamond">
					<span class="step-left">
						<span class="step-top">
							<span class="step-number">${number}.</span>
							Choose Diamond
						</span>
						${this.renderDiamondLeftBottom()}
					</span>
					<span class="step-right">
						${this.renderDiamondRight()}
					</span>
				</button>
			</div>
		`;
	}

	renderDiamondLeftBottom () {
		if (this.diamondSelected) {
			return html`
				<span class="step-bottom step-bottom__selection">
					<div class="selection-name">${this.diamondName}</div>
					<div class="selection-price">${this.formatCurrency(this.store?.diamond?.product?.price)}</div>
				</span>
				<span class="selection-edit-remove">
					<a class="selection-edit step-link" href="${this.store?.editDiamondHref}" @click="${(e) => this.trackEdit(e, 'Diamond')}" aria-label="Edit Diamond">
						Edit
					</a>
					<a class="selection-remove step-link" href="${this.store.removeDiamondStepHref}" @click="${() => this.trackRemove('Diamond')}" aria-label="Remove Diamond">
						Remove
					</a>
				</span>
			`;
		}

		if (this.store?.step !== DIAMOND_STEP) {
			return html`
				<span class="step-bottom step-bottom__no-selection step-link">
					Browse Diamonds
				</span>
			`;
		}

		return nothing;
	}

	renderDiamondRight () {
		if (!this.diamondSelected) {
			return html`
				<span class="icon-diamond step-icon" aria-hidden="true"></span>
			`;
		}

		return html`
			<span class="selection-image">
				<img .src="${DIAMOND_IMAGES[this.diamondShape]}" .alt="${this.diamondName}" />
			</span>
			<span class="selection-edit-remove">
				<a class="selection-edit step-link" href="${this.store?.editDiamondHref}" @click="${(e) => this.trackEdit(e, 'Diamond')}" aria-label="Edit Diamond">
					Edit
				</a>
				<a class="selection-remove step-link" href="${this.store.removeDiamondStepHref}" @click="${() => this.trackRemove('Diamond')}" aria-label="Remove Diamond">
					Remove
				</a>
			</span>
		`;
	}

	handleReviewClick (e) {
		if (this.store.reviewStepDisabled) {
			e.preventDefault();
			return false;
		}
		return true;
	}

	renderReviewStep () {
		const containerClassMap = {
			'is-active': this.store?.step === REVIEW_STEP,
			step: true,
			'step--review': true
		};
		const buttonClassMap = {
			'is-disabled': this.store.reviewStepDisabled,
			'step-button': true
		};

		return html`
			<div class="${classMap(containerClassMap)}">
				<a href="${this.store.reviewStepHref}" class="${classMap(buttonClassMap)}" @click="${this.handleReviewClick}" aria-disabled="${this.store.reviewStepDisabled}" aria-label="Review &amp; Checkout">
					<span class="step-inner-top">
						<span class="step-left">
							<span class="step-top">
								<span class="step-number">3.</span>
								Review<span class="step-review-extra-text"> &amp; Checkout</span>
							</span>
						</span>
						<span class="step-right">
							<span class="icon-eye-review step-icon" aria-hidden="true"></span>
						</span>
					</span>
					${this.renderReviewBottomText()}
				</a>
			</div>
		`;
	}

	renderReviewBottomText () {
		if (this.store?.step !== REVIEW_STEP) {
			return nothing;
		}

		return html`
			<span class="step-bottom">
				Congratulations, you've just designed your dream ring!
			</span>
		`;
	}

	updateStep (step) {
		if (this.store?.step === PRODUCT_SELECTION_STEP || this.store?.step === REVIEW_STEP) {
			switch (step) {
				case DIAMOND_STEP:
					window.location = this.store.diamondStepHref;
					break;
				case SETTING_STEP:
					window.location = this.store.settingStepHref;
					break;
				default:
					break;
			}

			return;
		}
		this.store?.setStep(step);
	}

	get settingSelected () {
		return this.store?.setting?.product?.id && this.store?.loaded;
	}

	get diamondSelected () {
		return this.store?.diamond?.product?.id && this.store?.loaded;
	}

	get diamondName () {
		return parseFloat(this?.store?.diamond?.product?.attributes?.carat).toFixed(2) + ' Carat ' + this?.store?.diamond?.product?.attributes?.shape;
	}

	formatCurrency (amount) {
		let amt = amount;
		if (typeof amount !== amt) {
			amt = parseFloat(amount);
		}

		return amt.toLocaleString('en-US', {
			currency: 'USD',
			style: 'currency'
		});
	}

	get diamondShape () {
		return this.store?.diamond?.product?.attributes?.shape?.toLowerCase()?.replace(/ /g, '-');
	}

	trackEdit (e, label) {
		e.stopImmediatePropagation();

		window.dataLayer = window.dataLayer || [];
		window.dataLayer.push({
			event: 'ga_event',
			/* eslint-disable camelcase */
			ga_event_action: 'Edit',
			ga_event_category: 'Ring Builder',
			ga_event_label: label,
			ga_event_non_interaction: false
			/* eslint-enable camelcase */
		});
	}

	trackRemove (label) {
		window.dataLayer = window.dataLayer || [];
		window.dataLayer.push({
			event: 'ga_event',
			/* eslint-disable camelcase */
			ga_event_action: 'Remove',
			ga_event_category: 'Ring Builder',
			ga_event_label: label,
			ga_event_non_interaction: false
			/* eslint-enable camelcase */
		});
	}
}

defineCustomElement('rb-status-bar', StatusBar);
